import _fieldDirectiveFinder from "./_fieldDirectiveFinder";
import {fromPairs} from "lodash/array";

export default ({typeDefs, resolvers}) => {
    // TODO
    return {
        typeDefs,
        resolvers
    };
}
